import { Box } from '@betterment/samba-react';
import { Link, useNavigate } from 'react-router-dom';

import { WorkflowLayout } from '../../../Shared/layout/WorkflowLayout';

export const AccountOwnership: React.FC = () => {
  const navigate = useNavigate();

  return (
    <WorkflowLayout
      pageTitle="Introduction"
      workflowTitle=""
      onBack={() => navigate(-1)}
      onClose={() => navigate('/')}
      size="small"
    >
      <Box
        css={{
          display: 'grid',
          gap: 'space.200',
        }}
      >
        <Link to="/add_account/self_directed_investing/investing_experience">Individual</Link>
        <Link to="/add_account/self_directed_investing/joint_taxable">Joint</Link>
        <Link to="/add_account/self_directed_investing/trust">Trust</Link>
      </Box>
    </WorkflowLayout>
  );
};
